/*
 * @Description: form表单组件的公用mixin
 */
import Vue from 'vue'
import { repairUnit } from '../../utils/style'
const Tips = Vue.extend({
  props: ['tips'],
  render() {
    if (this.tips) {
      return this.$createElement(
        'kui-tooltip',
        {
          props: {
            content: this.tips,
            placement: 'top-start',
            popperClass: 'kui-form-item-popper'
          }
        },
        [
          this.$createElement('i', {
            class: 'kui-icon-question kui-form-item-tips'
          })
        ]
      )
    }
    return null
  }
})

const LabelTips = Vue.extend({
  props: ['labelTips'],
  render() {
    if (this.labelTips) {
      return this.$createElement(
        'kui-tooltip',
        {
          props: {
            content: this.labelTips,
            placement: 'top',
            popperClass: 'kui-form-item-popper-label-tips'
          }
        },
        [
          this.$createElement('i', {
            class: 'kui-icon-question kui-form-item-label-tips'
          })
        ]
      )
    }
    return null
  }
})
export default {
  data() {
    return {
      tipEl: null,
      labelTipsEl: null
    }
  },
  inject: {
    SuiForm: {
      default: null
    },
    SuiFormPage: {
      default: null
    }
  },
  props: {
    // form表单中时，绑定的model中的值
    prop: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: [String, Boolean, Number, Array, Object, Date],
      required: false,
      default: null
    },
    size: {
      type: String,
      required: false,
      validator: function (value) {
        return ['medium', 'small', 'mini'].indexOf(value) !== -1
      }
    },
    inputWidth: {
      type: [String, Number],
      required: false,
      default: null
    },
    width: {
      type: [String, Number],
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      required: false
    },
    tips: {
      type: String,
      default: null
    },
    labelTips: {
      type: String,
      default: null
    }
  },
  computed: {
    val: {
      get() {
        if (this.prop && this.SuiForm) {
          return this.SuiForm.model[this.prop]
        } else {
          return this.value
        }
      },
      set(val) {
        if (this.prop && this.SuiForm) {
          this.SuiForm.model[this.prop] = val
        } else {
          this.$emit('input', val)
        }
      }
    },
    elMode() {
      return (this.$ELEMENT || {}).$mode || 'easy'
    },
    elSize() {
      if (this.$options.propsData.size === undefined && this.SuiForm) {
        return this.SuiForm.size
      }
      return this.size
    },
    elDisabled() {
      if (this.SuiForm && this.SuiForm.disabled !== undefined) {
        // disabled为数组时禁用单独某项或某几项，数组元素值为prop
        // disabled为true时禁用全部
        if (Array.isArray(this.SuiForm.disabled)) {
          return this.SuiForm.disabled.includes(this.prop)
        } else {
          return this.SuiForm.disabled || this.disabled
        }
      }
      return this.disabled
    },
    _width() {
      if (this.width === null) {
        return ((this.$ELEMENT || {}).inputWidth || {})[this.elMode] || 230
      } else {
        return this.width
      }
    },
    elWidth() {
      if (this.inputWidth) {
        return repairUnit(this.inputWidth)
      } else if (this.SuiForm.inputWidth) {
        return repairUnit(this.SuiForm.inputWidth)
      } else {
        return repairUnit(this._width)
      }
    }
  },
  watch: {
    val(val, oldVal) {
      if (this.$options._componentTag !== 'kui-tree-select') {
        this.$emit('change', val, oldVal)
      }
    },
    tips(val, oldVal) {
      this.tipEl && this.$el.parentNode.removeChild(this.tipEl)
      this.tipEl = null
      if (val) {
        this.tipEl = new Tips({ propsData: { tips: this.tips } }).$mount().$el
        this.$el.parentNode.appendChild(this.tipEl)
      }
    },
    labelTips(val, oldVal) {
      let labelEl = null
      const formItemEl = this.findElWithClassName(this.$el, 'el-form-item')
      if (formItemEl) {
        const labelEls = formItemEl.getElementsByTagName('label')
        if (labelEls.length) {
          labelEl = labelEls[0]
        }
      }
      if (labelEl) {
        this.labelTipsEl && labelEl.removeChild(this.labelTipsEl)
        this.labelTipsEl = null
        if (val) {
          this.labelTipsEl = new LabelTips({ propsData: { labelTips: this.labelTips } }).$mount().$el
          labelEl.appendChild(this.labelTipsEl)
        }
      }
    }
  },
  created() {},
  mounted() {
    // 混入对象的钩子将在组件自身钩子之前调用。
    this.handleMounted()
    this.handleTestId()
    if (this.tips) {
      this.tipEl = new Tips({ propsData: { tips: this.tips } }).$mount().$el
      this.$el.parentNode.appendChild(this.tipEl)
    }
    if (this.labelTips) {
      this.labelTipsEl = new LabelTips({ propsData: { labelTips: this.labelTips } }).$mount().$el
      const formItemEl = this.findElWithClassName(this.$el, 'el-form-item')
      if (formItemEl) {
        const labelEls = formItemEl.getElementsByTagName('label')
        if (labelEls.length) {
          labelEls[0].appendChild(this.labelTipsEl)
        }
      }
    }
  },
  methods: {
    // 递归获取element的祖宗节点中第一个拥有className的节点
    findElWithClassName(element, className) {
      if (element.classList.contains(className)) {
        return element
      } else if (element.parentNode) {
        return this.findElWithClassName(element.parentNode, className)
      } else {
        return null
      }
    },
    handleMounted() {
      if (typeof this.$attrs['mounted'] === 'function') {
        this.$attrs['mounted'](this)
      } else {
        this.$emit('mounted', this)
      }
    },
    handleTestId() {
      if (this.$attrs['is-test'] === true) {
        let name = this.$options.name
        let allowTestComponents = this.$attrs['allow-test-components']
          ? this.$attrs['allow-test-components']
          : ['SuiInput', 'SuiSelect', 'SuiDate', 'SuiTime', 'SuiNumber', 'SuiSwitch', 'SuiAuto', 'SuiTextarea']
        if (allowTestComponents.indexOf(name) === -1) {
          return
        }
        let inputEls = this.$el.querySelectorAll('input,textarea')
        if (inputEls.length) {
          inputEls.forEach((element) => {
            if (this.$attrs['test-id']) {
              element.dataset['testId'] = this.$attrs['test-id'] + (this.$attrs['test-suffix'] ? '-' + this.$attrs['test-suffix'] : '')
            } else if (this.prop) {
              element.dataset['testId'] = this.prop + (this.$attrs['test-suffix'] ? '-' + this.$attrs['test-suffix'] : '')
            }
          })
        }
      }
    },
    handleBlur(event) {
      this.$emit('blur', this.val, event)
    },
    handleFocus(event) {
      // 表单中的输入项，聚焦时，去掉校验信息。
      if (this.SuiForm && this.prop) {
        this.SuiForm.clearValidate(this.prop)
      }
      this.$emit('focus', this.val, event)
    },
    handleClear() {
      this.$emit('clear', this.val)
    },
    /**
     * @description: 触发上层组件的指定事件。
     * @param componentName 上层组件name
     * @param eventName 事件名称
     * @param params 事件参数
     * @return:
     */
    dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root
      var name = parent.$options.componentName
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent

        if (parent) {
          name = parent.$options.componentName
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/SimbartUI/components/form/formMixin.js